import axios from 'axios';
import _ from 'underscore';
import Swiper from 'swiper/dist/js/swiper';
import { TweenLite } from 'gsap';
import markerIcons from '../../map/marker-icons';
import template from './template.js';

import mapStyles from '../../map/map-styles';
import infoWindow from '../../map/info-window';
import infoWindowMobile from '../../map/info-window-mobile.js';
import showEnquiries from '../../components/show-enquiries.js';

console.log("The search results page");
Vue.config.devtools = true;
export default () => {

    //expose the vue app on the dom for test and debugging
    window.atom42app = new Vue({
        template: template,
        el: '#app',

        data: {
            appIsReady: false,
            hoveredBuilding: -1,
            activeBuilding: -1,
            markersResultList: [],
            searchInput: '',
            filterOpened: false,
            selectedFilters: {},
            selectedAmenitiesFilters: {},
            availableFilters: {},
            availableAmenitiesFilters: {},
            filtersArr: [],
            filterPeople: 0,
            filterChanged: false,
            filterAmenitiesChanged: false,
            mobileListOpened: false,
            mapOpened: true,
            resultsText: '',
            selectedHiddenMarker: false,
            zoomIsFixedOnce: false,
            hasSelectedAmenities: false,
            hasSelectedOffices: false,
            hasSelectedTeamSize: false,
            minTeamSize: "",
            maxTeamSize: "",
            cities: [
                'london',
                'birmingham',
                'bristol',
                'edinburgh',
                'leeds',
                'manchester',
                'milton keynes',
                'reading',
            ],
            allMarkers: {},
            selectedCity: '',
            productType: '',
            tier: '',
            isAllAmenitiesShown: false,
            capacityFilters: [
                '1-8',
                '9-20',
                '21-30',
                '30+'
            ],
            selectedCapacityFilters: {
                '1-8': false,
                '9-20': false,
                '21-30': false,
                '30+': false
            },
            headerHeight: 0,
            apiFilterParams: {
                team_size: '',
                space_type: '',
                amenities: '',
            },
            urlParams: null,
            searchTimeout: null,
            apiLoading: false,
            filtersNum: 0,
            headerElHeight: 0,
            mapElHeight: 0,
            searchResultsHeaderElHeight: 0,
            mobileInfoWindowOpened: false,
            mobileInfoWindowHtml: '',
            mobileInfoWindowBuilding: null,
            searchPlaceholder: 'Where would you like to search?',
            capacityAvailable: false,
            isValidSuggestion: false,
            ukFetch: false,
            isInitialLoad: true,
        },

        computed: {
            filterButtonText() {
                const length = this.filtersArr.length;
                return 'Filter ' + (length > 0 ?
                    `(${length})` :
                    '<span class="filter-desk-text">products</span>');
            },
            displayedAmenitiesFilters() {
                // Convert the object keys to an array
                const amenitiesKeys = Object.keys(this.selectedAmenitiesFilters);
                // Return either the full array or a sliced portion
                return this.isAllAmenitiesShown ? amenitiesKeys : amenitiesKeys.slice(0, 9);
            },
            displayedCapacityFilters() {
                return this.capacityFilters.concat(this.capacityFilters);
            },

            elementsHeight() {
                return {
                    '--header-height': `${this.headerElHeight}px`,
                    '--map-height': `${this.mapElHeight}px`,
                    '--search-results-header-height': `${this.searchResultsHeaderElHeight}px`,
                };
            },
        },

        created() {
            this.searchErrorValue = '';
            this.buildings = {};
            this.map = null;
            this.selectedFiltersOnOpen = {};
            this.selectedAmenitiesOnOpen = {};
            this.markersAround = null;
            this.enquieresPopupContainer = document.getElementById('popup-enquiries');
            this.parseUrlParams();
            this.statusOk = google.maps.places.PlacesServiceStatus.OK;

            // console.log("Created Invoked");
        },

        mounted() {

            window.addEventListener('load', () => {
                showEnquiries();
            });

            const homeUrl = window.location.origin;
            const apiUrl = `${homeUrl}/wp-json/landmark/v1/locations`;
            this.apiLoading = true;

            if (this.urlParams.space_type === 'meeting rooms') {
                this.capacityAvailable = true;
            }
            if (this.urlParams.value) {
                let formatedValue = this.urlParams.value.replace(/\+/g, ' ');
                formatedValue = formatedValue.toLowerCase();
                if ('united kingdom' === formatedValue) {
                    this.ukFetch = true;
                    // Set radius to 1000000 meters (1000 km) to fetch all UK locations
                    this.setDataToUrl({ radius: 10000 });

                }
            }

            // Unified geocode and fetch logic
            const geocodeAndFetch = (geocodeParams) => {
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode(geocodeParams, (results, status) => {
                    if (status === 'OK' && results[0]) {
                        const location = results[0].geometry.location;

                        const lat = location.lat();
                        const lng = location.lng();

                        // Update URL parameters and fetch locations
                        this.setDataToUrl({ lat, lng });
                        this.fetchLocations(apiUrl, { ...this.urlParams, lat, lng });
                    } else {
                        console.error('Geocoding failed:', status);
                        this.fetchLocations(apiUrl, this.urlParams); // Fallback to fetching without lat/lng
                    }
                });
            };

            // Decide whether to use placeId or value for geocoding
            if (this.urlParams.placeId) {
                console.log('Geocoding placeId:', this.urlParams.placeId);
                geocodeAndFetch({ placeId: this.urlParams.placeId })
            } else if (this.urlParams.value) {
                console.log('Geocoding:', this.urlParams.value);
                geocodeAndFetch({ address: this.urlParams.value })
            } else {
                // Directly fetch locations if no placeId or value is provided
                this.fetchLocations(apiUrl, this.urlParams);
            }



            // handle form events
            this.$refs.searchForm.onsubmit = e => e.preventDefault();
            // this.$refs.searchForm.oninput = () => this.searchInput = this.$refs.searchInput.value;
            this.$refs.searchForm.oninput = () => {
                clearTimeout(this.searchTimeout); // Clear existing timeout
                this.searchInput = this.$refs.searchInput.value;

                // Set a new timeout
                this.searchTimeout = setTimeout(() => {
                    // Check if the input is empty
                    if (this.searchInput.trim() === '') {
                        this.showAllBuildings(); // Show all UK locations
                        this.generateList();
                        // Optionally, reset the URL parameters
                        this.setDataToUrl({ value: '' });
                    }
                }, 1500); // Adjust the timeout duration as needed (e.g., 1500 for 1.5 seconds)
            };
            this.$refs.searchForm.onreset = () => this.searchInput = '';

            //reload on click browser back button
            window.addEventListener('popstate', () => location.reload());

            // init buildings mobile popup slider
            this.buildingsMobilerSlider = new Swiper(this.$refs.buildingsListMobile, {
                slidesPerView: 'auto',
            });

            this.displayedCapacityFilters = this.capacityFilters.map(filter => filter);

            // get header height
            this.calculateHeaderHeight();
            window.addEventListener('resize', this.calculateHeaderHeight);
            this.calcElsHeights();
            this.$nextTick(() => {
                this.calcElsHeights();
            });
            window.addEventListener('resize', this.calcElsHeights);

            if (window.innerWidth < 1024) {
                this.searchPlaceholder = 'Search a location';
            }
            // console.log("Mounted Invoked");
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.calculateHeaderHeight);
            window.removeEventListener('resize', this.calcElsHeights);
        },
        watch: {
            hoveredBuilding(current, prev) {
                if (current === -1) { // unhover
                    if (this.activeBuilding === +prev) return;
                    this.unHoverMarker(prev);
                } else { // hover
                    const building = this.buildings[current];
                    const marker = building.marker;
                    const icon = building.markerIsOutFilter || building.markerIsOutArea ?
                        this.markerIcons(building.location_source).hovered :
                        this.markerIcons(building.location_source).hovered;
                    const zIndex = icon === this.markerIcons(building.location_source).hovered ? 3 : 1;
                    marker.setIcon(icon);
                    marker.setZIndex(zIndex);
                }
                //console.log("Watch hoveredBuilding Invoked");
            },

            activeBuilding(current, prev) {
                if (!this.buildings[prev]) return;
                this.unHoverMarker(prev);
                const marker = this.buildings[prev].marker;
                if (marker.infoWindow) {
                    marker.infoWindow.close();
                    marker.infoWindow = null;
                }
                //console.log("Watch activeBuilding Invoked");
            },

            markersResultList(current, prev) {
                if (window.innerWidth < 1024) {
                    const currentLength = current.length;

                    for (let i = 0; i < currentLength; i++) {

                        const resetSlider = () => {
                            if (!this.mapOpened) return;
                            setTimeout(() => {
                                this.buildingsMobilerSlider.update();
                                this.buildingsMobilerSlider.slideTo(0);
                            }, 0);
                        };

                        if (!current[i] || !prev[i]) {
                            resetSlider();
                            break;
                        } else {
                            if (current[i].id !== prev[i].id) {
                                resetSlider();
                                break;
                            }
                        }
                    }
                    // console.log("Watch markersResultList Invoked");
                }
            },
        },

        methods: {
            onChangeMinTeam: function (e) {
                let id = e.target.value;
                this.minTeamSize = id;
                console.error(id);
            },

            onChangeMaxTeam: function (e) {
                let id = e.target.value;
                this.maxTeamSize = id;
                console.error(id);
            },

            showEnquieries() {
                let buildingFormElement = document.getElementById('building-desktop-popup');
                // Hide/Show form when header is clicked.
                if (window.getComputedStyle(buildingFormElement).display === 'block') {
                    buildingFormElement.style.display = 'none';
                } else {
                    buildingFormElement.style.display = 'block';
                }
            },

            onChangeSortOrder(event) {
                let howToSort = event.target.value;
                if (howToSort === 'asc') {
                    this.markersResultList = _.sortBy(this.markersResultList, 'min_price', 'asc');
                } else {
                    this.markersResultList = _.sortBy(this.markersResultList, 'max_price', 'desc');
                }
            },
            fetchLocations(apiUrl, params) {
                // If we need to keep the tier in the URL remove the following block
                if (this.isInitialLoad) {
                    if (this.urlParams.tier) {
                        params.tier = this.urlParams.tier;
                    }
                    // After initial load, set isInitialLoad to false to prevent including the tier in future requests
                    this.isInitialLoad = false;
                }
                axios.get(apiUrl, { params })
                    .then(response => {
                        this.initMap(response.data.locations);
                        this.setFiltersFromUrlParams();
                    })
                    .then(() => {
                        if (this.urlParams.space_type) {
                            // Reset all selectedFilters first
                            Object.keys(this.selectedFilters).forEach(key => {
                                this.selectedFilters[key] = false;
                            });

                            // Split the params.space_type by comma to handle multiple filters
                            const spaceTypes = this.urlParams.space_type.split(',');
                            spaceTypes.forEach(type => {
                                // The URL might encode spaces as plus signs (+), so replace them with spaces
                                const decodedType = decodeURIComponent(type).replace(/\+/g, ' ');
                                // Now update the selectedFilters, ensuring keys match the text exactly
                                if (this.selectedFilters.hasOwnProperty(decodedType)) {
                                    this.selectedFilters[decodedType] = true;
                                }
                            });
                        } else {
                            // If no space_type parameter, reset all selectedFilters
                            Object.keys(this.selectedFilters).forEach(key => {
                                this.selectedFilters[key] = false;
                            });
                        }

                        if (this.urlParams.amenities) {
                            Object.keys(this.selectedAmenitiesFilters).forEach(key => {
                                this.selectedAmenitiesFilters[key] = false;
                            });

                            this.urlParams.amenities.forEach(amenity => {
                                this.selectedAmenitiesFilters[amenity] = true;
                            });
                        } else {
                            Object.keys(this.selectedAmenitiesFilters).forEach(key => {
                                this.selectedAmenitiesFilters[key] = false;
                            });
                        }

                    }).then(() => {
                        this.filtersNum = 0;
                        if (this.urlParams.space_type) {
                            this.filtersNum += 1;
                        }

                        if (this.urlParams.amenities.length > 0) {
                            this.filtersNum += 1;
                        }

                        if (this.urlParams.capacity) {
                            this.filtersNum += 1;
                        }
                    })
                    .then(() => {
                        this.apiLoading = false;
                    }).then(() => {
                        if (this.ukFetch) {
                            this.ukFetch = false;
                            setTimeout(() => {
                                document.querySelector('.search-form input').value = 'United Kingdom';
                                this.searchInput = 'United Kingdom';
                                this.searchErrorValue = 'United Kingdom';
                                this.map.setZoom(6);
                            }, 800); // Google debounce is 600ms so extra 200ms to be sure
                        }
                    })
                    .catch(error => console.log(error));
            },
            toggleShowAllAmenities() {
                this.isAllAmenitiesShown = !this.isAllAmenitiesShown;
            },

            santizieStringToUrlApproprite(string) {
                return string.toLowerCase().replace(/\s+/g, '-');
            },

            reset() {
                this.fillInput();
                this.activeBuilding = -1;
                this.showAllBuildings();
                this.generateList();
                this.setDataToUrl();
                const newUrl = location.protocol + '//' + location.host + location.pathname;
                history.pushState({ path: newUrl }, '', newUrl);
                // console.log("Method reset Invoked");
            },

            openEnquiresPopup(marker) {
                if (!this.enquieresPopupContainer) return;

                if (this.enquieresPopupContainer.classList.contains('opened')) {
                    this.enquieresPopupContainer.style.visibility = 'hidden';
                    this.enquieresPopupContainer.classList.remove('opened');
                } else {
                    this.enquieresPopupContainer.classList.add('opened');
                    this.enquieresPopupContainer.style.visibility = '';
                }

                if (marker &&
                    marker.book_a_meeting_room_button_details &&
                    marker.book_a_meeting_room_button_details.url
                ) {
                    const url = marker.book_a_meeting_room_button_details.url;

                    $('button span:contains("Book Meeting Room")')
                        .parent()
                        .attr("onclick", "window.open('" + url + "', '_blank')");
                }

                const closeButton = document.getElementById('popup-enquiries-close-button');
                if (closeButton) {
                    closeButton.addEventListener('click', () => {
                        this.enquieresPopupContainer.style.visibility = 'hidden';
                        this.enquieresPopupContainer.classList.remove('opened');
                    });
                }
            },

            showEnquieries() {
                let buildingFormElement = document.getElementById('building-desktop-popup');
                // Hide/Show form when header is clicked.
                if (window.getComputedStyle(buildingFormElement).display === 'block') {
                    buildingFormElement.style.display = 'none';
                } else {
                    buildingFormElement.style.display = 'block';
                }
            },

            unHoverMarker(id) {
                const building = this.buildings[id];
                const marker = building.marker;
                const icon = building.markerIsOutFilter || building.markerIsOutArea ?
                    this.markerIcons(building.location_source).default :
                    this.markerIcons(building.location_source).default;
                const zIndex = icon === this.markerIcons(building.location_source).default ? 2 : 1;
                marker.setIcon(icon);
                marker.setZIndex(zIndex);
                // console.log("Method unHoverMarker Invoked");
            },
            toggleFilterOption(selectedKey) {
                if (!selectedKey) return;

                // Toggle the state of the clicked filter
                this.selectedFilters[selectedKey] = !this.selectedFilters[selectedKey];

                // Update the apiFilterParams.space_type with all selected filters
                // Assuming you need to convert spaces to '+' for URL compatibility
                this.apiFilterParams.space_type = Object.entries(this.selectedFilters)
                    .filter(([key, value]) => value)
                    .map(([key, value]) => encodeURIComponent(key).replace(/%20/g, '+'))
                    .join(',');

                // Update the URL with the new space_type
                this.setDataToUrl({ space_type: this.apiFilterParams.space_type });

                // Special handling for 'meeting rooms' due to its influence on capacity availability
                if (selectedKey === 'meeting rooms') {
                    this.capacityAvailable = this.selectedFilters[selectedKey];
                    if (this.capacityAvailable) {
                        // If meeting rooms are selected and you need to add capacity to URL, do it here
                        // Example: this.setDataToUrl({ capacity: 'your_capacity_value' });
                    } else {
                        // Clear capacity from URL if meeting rooms are not selected
                        this.setDataToUrl({ capacity: '' });
                        // Unselect all capacity filters
                        Object.keys(this.selectedCapacityFilters).forEach(key => {
                            this.selectedCapacityFilters[key] = false;
                        });
                    }
                }

                // Detect any changes in filters compared to the initial state when the component was mounted
                this.filterChanged = !Object.entries(this.selectedFiltersOnOpen)
                    .every(([key, value]) => this.selectedFilters[key] === value);
            },

            toggleFilterCapacityOption(key) {
                // Check if the selected key is already active
                if (this.selectedCapacityFilters[key]) {
                    // If already selected, unselect it
                    this.selectedCapacityFilters[key] = false;

                    // Remove capacity from the URL
                    this.setDataToUrl({ capacity: '' });
                } else {
                    // If not selected, first reset all other filters
                    Object.keys(this.selectedCapacityFilters).forEach(k => {
                        this.selectedCapacityFilters[k] = false;
                    });

                    // Then select the clicked filter
                    this.selectedCapacityFilters[key] = true;

                    // Update URL with the selected capacity filter
                    this.setDataToUrl({ capacity: key });
                }
            },

            toggleFilterAmenitiesOption(key) {
                if (!key) return;
                this.selectedAmenitiesFilters[key] = !this.selectedAmenitiesFilters[key];
                this.filterChanged = false;
                const onOpenKeysAmenities = Object.keys(this.selectedAmenitiesOnOpen);
                const currentKeysAmenities = Object.keys(this.selectedAmenitiesFilters);

                if (onOpenKeysAmenities.length !== currentKeysAmenities.length) {
                    return;
                }
                onOpenKeysAmenities.forEach(key => {

                    if (this.selectedAmenitiesFilters[key] !== this.selectedAmenitiesOnOpen[key]) {
                        this.filterChanged = true;
                    }
                });

                // Gather all selected amenities
                const selectedAmenities = Object.keys(this.selectedAmenitiesFilters).filter(key => this.selectedAmenitiesFilters[key]);
                // Update the URL
                this.setDataToUrl({ amenities: selectedAmenities.join(',') });
                // console.log("Method toggleFilterAmenitiesOption Invoked");
            },

            toggleFilter() {
                // console.log('I get toggle');
                this.filterOpened = !this.filterOpened;
                this.filterChanged = false;
                if (this.filterOpened) {
                    Object.keys(this.selectedFilters).forEach(key => {
                        this.selectedFiltersOnOpen[key] = this.selectedFilters[key];
                    });
                    Object.keys(this.selectedAmenitiesFilters).forEach(key => {
                        this.selectedAmenitiesOnOpen[key] = this.selectedAmenitiesFilters[key];
                    });
                }

                // Toggle class on header
                const headerFixed = document.querySelector('.header--fixed');
                const body = document.querySelector('body');
                if (!this.filterOpened) {
                    headerFixed.classList.remove('z-index--100');
                    body.classList.remove('overflow-hidden');
                } else {
                    headerFixed.classList.add('z-index--100');
                    body.classList.add('overflow-hidden');
                }

                // console.log("Method toggleFilter Invoked");
            },

            backToFilteredResults() {
                this.selectedHiddenMarker = false;
                this.filterList();
                this.activeBuilding = -1;
                TweenLite.to(window, 0, {
                    scrollTo: 0,
                });
                // console.log("Method backToFilteredResults Invoked");
            },

            // NOT USED:
            checkFiltersAvailability() {
                // console.log("Method checkFiltersAvailability Invoked");
                let filtersArr = [];

                Object.keys(this.selectedFilters).forEach(key => {
                    this.availableFilters[key] = true;
                    filtersArr.push(key);

                });

                Object.keys(this.selectedAmenitiesFilters).forEach(key => {
                    this.availableAmenitiesFilters[key] = true;
                    filtersArr.push(key);
                });

                this.markersResultList.forEach(building => {
                    let prodsArr = [];
                    let amenArr = [];
                    const products = building.products;
                    const amenities = building.amenities;
                    if (!products) return;
                    if (!amenities) return;

                    Object.keys(products).forEach(key => {
                        prodsArr.push(key);
                    });
                    Object.keys(amenities).forEach(key => {
                        amenArr.push(key);
                    });

                    if (prodsArr.length > 0) {
                        filtersArr.forEach(filter => {
                            if (prodsArr.includes(filter)) {
                                this.availableFilters[filter] = true;
                            }
                        });
                    }

                    if (amenArr.length > 0) {
                        filtersArr.forEach(filter => {
                            if (amenArr.includes(filter)) {
                                this.availableAmenitiesFilters[filter] = true;
                            }
                            //this was added new 26.11.2020
                            this.availableAmenitiesFilters[filter] = true;
                        });
                    }

                });
            },

            applyFilter() {
                this.searchErrorValue = '';
                this.activeBuilding = -1;
                this.filterOpened = false;
                this.filtersArr = [];
                this.filtersAmenitiesArr = [];

                Object.keys(this.selectedFilters).forEach(key => {
                    if (this.selectedFilters[key]) {
                        this.filtersArr.push(key);  // create selected filters array
                        this.hasSelectedOffices = true;

                        // check if meeting rooms is selected and if it is, set capacity to true
                        if (key === 'meeting rooms') {
                            this.capacityAvailable = true;
                        }
                    }
                }, this);

                Object.keys(this.selectedAmenitiesFilters).forEach(key => {

                    if (this.selectedAmenitiesFilters[key]) {
                        this.filtersArr.push(key);  // create selected filters array
                        this.hasSelectedAmenities = true;
                    }
                }, this);

                Object.keys(this.buildings).forEach(key => {
                    const building = this.buildings[key];
                    const people = building.people;
                    const marker = building.marker;
                    if (this.filtersArr.length === 0 && people > this.filterPeople) {
                        building.markerIsOutFilter = false;
                        if (building.markerIsOutArea) return;
                        marker.setIcon(this.markerIcons(building.location_source).default);
                        marker.setZIndex(2);
                        return;
                    }

                    let filterIsOk = false;
                    const products = building.products;
                    if (products && people > this.filterPeople) {
                        const prodArr = Object.keys(products);
                        const prodArrLength = prodArr.length;
                        for (let i = 0; i < prodArrLength; i++) {
                            if (this.filtersArr.includes(prodArr[i])) {
                                filterIsOk = true;
                                break;
                            }
                        }
                    }
                    //stefan change
                    const amenities = building.amenities;
                    if (amenities && people > this.filterPeople) {
                        const prodArr = Object.keys(products);
                        const prodArrLength = prodArr.length;
                        for (let i = 0; i < prodArrLength; i++) {
                            if (this.filtersArr.includes(prodArr[i])) {
                                filterIsOk = true;
                                break;
                            }
                        }
                    }

                    const markerIcon = filterIsOk ?
                        this.markerIcons(building.location_source).default :
                        this.markerIcons(building.location_source).hidden;
                    building.markerIsOutFilter = !filterIsOk;
                    if (building.markerIsOutArea) return;
                    marker.setIcon(markerIcon);
                    marker.setZIndex(filterIsOk ? 2 : 1);
                });

                this.filterList();
                TweenLite.to(window, 0, {
                    scrollTo: 0,
                });
            },

            fillInput(value = '') {
                this.$refs.searchInput.value = value;
                this.searchInput = value;
            },

            setDataToUrl(data = {}) {
                const search = new URLSearchParams(location.search);
                const id = data.id;
                const value = data.value;
                const lat = data.lat;
                const lng = data.lng;
                const space_type = data.space_type;
                const amenities = data.amenities;
                const capacity = data.capacity;
                const place_id = data.placeId;
                const radius = data.radius;

                if (id !== undefined) {
                    search.set('place_id', id);
                }
                if (id === '') {
                    search.delete('place_id');
                }

                if (place_id !== undefined) {
                    search.set('place_id', place_id);
                }
                if (place_id === '') {
                    search.delete('place_id');
                }

                if (value !== undefined) {
                    search.set('value', value);
                }
                if (value === '') {
                    search.delete('value');
                }
                if (lat !== undefined && lng !== undefined) {
                    search.set('lat', lat);
                    search.set('lng', lng);
                }
                if (lat === '' && lng === '') {
                    search.delete('lat');
                    search.delete('lng');
                }
                // Space type
                if (space_type !== undefined) {
                    search.set('space_type', space_type);
                }
                if (space_type === '') {
                    search.delete('space_type');
                }

                // Amenities
                if (amenities !== undefined) {
                    search.set('amenities', amenities);
                }
                if (amenities === '') {
                    search.delete('amenities');
                }

                // Capacity
                if (capacity !== undefined) {
                    search.set('capacity', capacity);
                }
                if (capacity === '') {
                    search.delete('capacity');
                }

                if (radius !== undefined) {
                    search.set('radius', radius);
                }
                if (radius === '') {
                    search.delete('radius');
                }

                const newurl = location.protocol + '//' + location.host +
                    location.pathname + `?${search.toString()}`;
                history.pushState({ path: newurl }, '', newurl);
            },

            getDataFromUrl() {
                let search = new URLSearchParams(location.search);
                return {
                    placeId: search.get('place_id'),
                    lat: +search.get('lat'),
                    lng: +search.get('lng'),
                    value: search.get('value'),
                    filter: search.get('filter'),
                    radius: search.get('radius'),
                    people: search.get('people'),
                    product_type: search.get('product_type'),
                    tier: search.get('tier'),
                    space_type: search.get('space_type'),
                };
            },

            parseUrlParams() {
                // Parse the URL parameters and store them in data
                let searchParams = new URLSearchParams(window.location.search);
                this.urlParams = {
                    value: searchParams.get('value'),
                    capacity: searchParams.get('capacity'),
                    space_type: searchParams.get('space_type'),
                    amenities: searchParams.get('amenities') ? searchParams.get('amenities').split(',') : [],
                    placeId: searchParams.get('place_id'),
                    lat: searchParams.get('lat'),
                    lng: searchParams.get('lng'),
                    radius: searchParams.get('radius'),
                    tier: searchParams.get('tier') || '',
                };
            },
            setFiltersFromUrlParams() {
                // Set filters based on URL parameters
                this.filtersArr = []; // Clear the array first

                if (this.urlParams.space_type && this.selectedFilters.hasOwnProperty(this.urlParams.space_type)) {
                    this.selectedFilters[this.urlParams.space_type] = true;
                    this.filtersArr.push(this.urlParams.space_type); // Add to filters array
                }
                if (this.urlParams.amenities && this.urlParams.amenities.length > 0) {
                    this.urlParams.amenities.forEach(amenity => {
                        if (this.selectedAmenitiesFilters.hasOwnProperty(amenity)) {
                            this.selectedAmenitiesFilters[amenity] = true;
                            this.filtersArr.push(amenity); // Add to filters array
                        }
                    });
                }
                if (this.urlParams.capacity && this.selectedCapacityFilters.hasOwnProperty(this.urlParams.capacity)) {
                    this.selectedCapacityFilters[this.urlParams.capacity] = true;
                    this.filtersArr.push(this.urlParams.capacity); // Add to filters array
                }
            },

            generateResultText() {
                const searchErrorValue = this.searchErrorValue;
                let text = 'We can’t find any results matching your criteria. Please try changing your filters or location.';
                let filters = '';
                const markersLength = this.markersResultList.length;
                if (searchErrorValue) {
                    // text = `There is no place like ${searchErrorValue}, showing all buildings`;
                    text = `We can’t find any results matching your criteria. Please try changing your filters or location.`;
                } else if (markersLength > 0) {
                    if (this.filtersArr.length > 0) {
                        this.filtersArr.forEach((filter, index, arr) => {
                            filters += ` ${filter}` + (index === arr.length ? '' : ',');
                        });
                    }
                    // if (this.filterPeople > 0) {
                    //     text = `We have found ${markersLength} building${markersLength > 1 ? 's' : ''} for ${this.filterPeople} people that match your search`;
                    // } else if (filters) {
                    //     text = `We have found ${markersLength} building${markersLength > 1 ? 's' : ''} for ${filters}`;

                    // } else {
                    //     text = `We have found ${markersLength} building${markersLength > 1 ? 's' : ''} that match your search`;
                    // }

                    text = `We have found ${markersLength} building${markersLength > 1 ? 's' : ''} that match your search`;
                }
                this.resultsText = text

                // Trigger window resize to update the map
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                }, 200);
            },

            clearFilters() {
                // Reset space type filters
                Object.keys(this.selectedFilters).forEach(key => {
                    this.selectedFilters[key] = false;
                });

                // Reset amenities filters
                Object.keys(this.selectedAmenitiesFilters).forEach(key => {
                    this.selectedAmenitiesFilters[key] = false;
                });

                // Reset capacity filters
                Object.keys(this.selectedCapacityFilters).forEach(key => {
                    this.selectedCapacityFilters[key] = false;
                });


                this.filtersArr = [];
                this.filterPeople = 0;
                this.filterChanged = false;
                this.filterAmenitiesChanged = false;

                this.setDataToUrl({ space_type: '', amenities: '', capacity: '' });
                this.filtersNum = 0;

                // Do not hide the filter panel
                // this.toggleFilter();
            },

            resetAll() {
                this.setDataToUrl({ value: 'United+Kingdom' });
                this.setDataToUrl({ placeId: 'ChIJqZHHQhE7WgIReiWIMkOg-MQ' });
                this.setDataToUrl({ lat: '54.237933' });
                this.setDataToUrl({ lng: '-2.36967' });

                this.fillInput('');
                this.activeBuilding = -1;
                // API endpoint
                let apiUrl = `${window.location.origin}/wp-json/landmark/v1/locations`;
                this.apiLoading = true;
                axios.get(apiUrl, { params: { value: 'United Kingdom' } })
                    .then(response => {
                        // Process and update the data
                        this.allMarkers = response.data.locations;
                        this.generateResultText();
                        this.initMap(this.allMarkers);
                    }).then(() => {
                        this.apiLoading = false;
                    })

            },
            /**
             * Filters the list
             * @method filterList
             */
            filterList() {
                // console.log('This generates the filter list ');

                const outputArr = [];
                if (this.selectedHiddenMarker) {
                    this.markersResultList = [this.selectedHiddenMarker];
                    return;
                }
                const isPeopleOk = people => {
                    return people > this.filterPeople;
                };

                this.markersAround.forEach(id => {
                    const building = this.buildings[id];
                    this.buildingAmenities = building.amenities;
                    const products = building.products;
                    //change stefan
                    const amenities = building.amenities;
                    const people = building.people;
                    let productsArr = [];
                    //change stefan
                    let amenitiesArr = [];
                    if (!products) return;
                    if (!amenities) return;

                    Object.keys(products).forEach(key => {
                        productsArr.push(key);
                    });

                    //stefan
                    Object.keys(amenities).forEach(key => {
                        amenitiesArr.push(key);
                    });

                    if (this.filtersArr.length === 0) {
                        if (isPeopleOk(people)) {
                            outputArr.push(building);
                        }
                    } else {
                        let buildingHasFilter = false;

                        this.filtersArr.forEach(filter => {
                            // console.log(filter);
                            //this does the filter logic
                            if (this.hasSelectedAmenities) {
                                if (amenitiesArr.includes(filter)) {
                                    buildingHasFilter = true;
                                }
                            }
                            if (this.hasSelectedOffices) {
                                if (productsArr.includes(filter)) {
                                    buildingHasFilter = true;
                                }

                                if (this.minTeamSize.length > 0) {
                                    // console.log('I get activated');
                                    if (this.buildings[id].team_size > this.minTeamSize) {
                                        buildingHasFilter = true;
                                    }
                                }

                                if (this.maxTeamSize.length > 0) {
                                    // console.log('I get activated');
                                    if (this.buildings[id].team_size < this.maxTeamSize) {
                                        buildingHasFilter = true;
                                    }
                                }
                            }

                            if (this.hasSelectedAmenities && this.hasSelectedOffices) {
                                if (productsArr.includes(filter)) {
                                    buildingHasFilter = true;
                                } else {
                                    buildingHasFilter = false;
                                }

                                if (amenitiesArr.includes(filter)) {
                                    buildingHasFilter = true;
                                }

                                if (this.minTeamSize.length > 0) {
                                    // console.log('I get activated');
                                    if (this.buildings[id].team_size > this.minTeamSize) {
                                        buildingHasFilter = true;
                                    }
                                }

                                if (this.maxTeamSize.length > 0) {
                                    // console.log('I get activated');
                                    if (this.buildings[id].team_size < this.maxTeamSize) {
                                        buildingHasFilter = true;
                                    }
                                }
                            }
                        }, this);

                        if (buildingHasFilter && isPeopleOk(people)) {
                            outputArr.push(building);
                        }
                    }
                }, this);

                this.markersResultList = outputArr;

                // check if searching for United Kingdom
                if (this.searchInput === 'United Kingdom' || this.ukFetch) {
                    console.log('UK Fetch filter');
                    this.markersResultList = this.markersResultList.sort((a, b) => {
                        return a.name.localeCompare(b.name);
                    });
                } else {
                    console.log('Location Fetch')
                    // Make the order default to ascending to not show thespace locations first
                    this.markersResultList = _.sortBy(this.markersResultList, 'distance', 'asc');
                }
                this.generateResultText();

                // Check if there are markers on the map
                if (this.markersResultList.length > 0) {
                    console.log('Markers found');
                    // Set the map center so that all markers are visible
                    this.fitMarkersWithinBounds(this.markersResultList);
                } else {
                    console.log('No markers found');
                }
            },

            fixZoom() {
                const radiusStep_1 = 3000; // meters
                const radiusStep_2 = 10000;
                const radiusStep_3 = 31000;
                const center = this.map.getCenter();
                let maxDistanceFromCenter = 0;

                const fitZoomToRadius = radius => {
                    const circle = new google.maps.Circle({
                        strokeOpacity: 0,
                        fillOpacity: 0,
                        map: this.map,
                        clickable: false,
                        center: center,
                        radius: radius,
                    });
                    // this.map.fitBounds(circle.getBounds());
                };

                const getRadius = () => {
                    if (this.zoomIsFixedOnce) { // only once
                        return null;
                    } else {
                        const dataUrl = this.getDataFromUrl();
                        return +dataUrl.radius;
                    }
                };

                const radiusFromURL = getRadius(); // radius from url

                if (!this.zoomIsFixedOnce && radiusFromURL) {
                    // fitZoomToRadius(radiusFromURL);
                }

                // Assign all markers to markersAround without filtering
                this.markersAround = Object.keys(this.buildings);

                this.markersAround.forEach(key => {
                    const building = this.buildings[key];
                    const marker = building.marker;
                    building.markerIsOutArea = false; // Since all markers are included, we assume none are out of area
                    if (building.markerIsOutFilter) return; // Skip if marker is out due to filter
                    marker.setZIndex(2);

                    const distance = google.maps.geometry.spherical.computeDistanceBetween(
                        center, marker.getPosition());
                    if (distance > maxDistanceFromCenter) {
                        maxDistanceFromCenter = distance;
                    }
                });

                // If not all markers are within the viewport, adjust zoom to fit all
                if (this.markersAround.length > 0) {
                    // fitZoomToRadius((!this.zoomIsFixedOnce && radiusFromURL) ? radiusFromURL : maxDistanceFromCenter);
                }
                this.zoomIsFixedOnce = true;
            },

            generateList() {
                this.fixZoom(); // fit zoom to show at list 1 marker and generate markersAround array

                // TODO : Remove
                // If location searched is london, we want to set a specific zoom closer
                if (this.selectedCity === 'london') {
                    this.map.setZoom(12);
                }

                // TODO : Add
                // // If search location is input, we want to set a specific zoom closer
                // const dataUrl = this.getDataFromUrl();
                // let value = dataUrl.value;
                // const placeId = dataUrl.placeId;
                //
                // value = value.toLowerCase();
                //
                // if (value || placeId) {
                //     //Places to ignore zoom
                //     if (
                //         value !== 'london' ||
                //         value !== 'edinburgh' ||
                //         value !== 'leeds' ||
                //         value !== 'reading' ||
                //         value !== 'milton+keynes' ||
                //         //London
                //         placeId !== 'ChIJdd4hrwug2EcRmSrV3Vo6llI' ||
                //         //Edinburgh
                //         placeId !== 'ChIJIyaYpQC4h0gRJxfnfHsU8mQ' ||
                //         //Leeds
                //         placeId !== 'ChIJmb1k2ko-eUgRqdwTAv26rVE' ||
                //         //Reading
                //         placeId !== 'ChIJtz092XggdEgRlHn6zn-f4So' ||
                //         //Milton Keynes
                //         placeId !== 'ChIJhYYjgvhMdkgRFH65TPedGhY'
                //     ) {
                //         this.map.setZoom(15);
                //     } else {
                //         this.map.setZoom(12);
                //     }
                // }

                // Sort the markers around by distance from center
                this.markersAround.sort((id_a, id_b) => {
                    const marker_a = this.buildings[id_a].marker;
                    const marker_b = this.buildings[id_b].marker;
                    return marker_a.distanceFromCenter - marker_b.distanceFromCenter;
                });
                // Check if the initial search is for a United Kingdom
                if (this.searchInput === 'United Kingdom' || this.ukFetch) {
                    console.log('UK Fetch');
                    // Sort alphabetically
                    this.markersAround.sort((id_a, id_b) => {
                        const name_a = this.buildings[id_a].name;
                        const name_b = this.buildings[id_b].name;
                        return name_a.localeCompare(name_b);
                    });

                }

                TweenLite.to(window, 0, {
                    scrollTo: 0,
                });
            },

            showAllBuildings(inputValue) {
                this.searchErrorValue = inputValue ? inputValue : '';
                this.fillInput();

                // If no specific input value is provided, set the map to show the entire UK
                if (!inputValue) {
                    // Define a center point for the UK - these coordinates are approximate
                    const ukCenter = { lat: 54.237933, lng: -2.36967 }; // UK approximate center
                    const ukZoom = 4; // Zoom level to show the entire UK

                    this.map.setCenter(ukCenter);
                    this.map.setZoom(ukZoom);
                } else {
                    // Existing logic to fit map to the bounds of all markers
                    const markerBounds = new google.maps.LatLngBounds();
                    Object.keys(this.buildings).forEach(key => {
                        const marker = this.buildings[key].marker;
                        const position = marker.getPosition();
                        const point = new google.maps.LatLng(position.lat(), position.lng());
                        markerBounds.extend(point);
                    });
                    this.map.fitBounds(markerBounds);
                }
            },

            // TODO : uncomment to zoom in more and reorder locations
            // zoomMapByGeometry(geometry, defaultZoom = false) {
            //     if (!defaultZoom && geometry.viewport) {
            //         this.map.fitBounds(geometry.viewport);
            //     } else {
            //         this.map.setCenter(geometry.location);
            //         this.map.setZoom(15);
            //     }
            // },

            // TODO : Remove
            zoomMapByGeometry(geometry) {
                if (geometry.viewport) {
                    this.map.fitBounds(geometry.viewport);
                    // Get the radius of the viewport in KM
                    let radius = google.maps.geometry.spherical.computeDistanceBetween(
                        geometry.viewport.getNorthEast(),
                        geometry.viewport.getSouthWest()
                    ) / 1000;
                    radius = radius / 2;
                    this.setDataToUrl({ radius: radius });
                    let zoomLevel = 9;
                    if (radius > 25) {
                        zoomLevel = 6;
                    } else if (radius > 20 && radius <= 25) {
                        zoomLevel = 12;
                    } else if (radius > 15 && radius <= 20) {
                        zoomLevel = 13;
                    } else if (radius > 10 && radius <= 15) {
                        zoomLevel = 14;
                    } else if (radius > 5 && radius <= 10) {
                        zoomLevel = 14;
                    } else if (radius < 5) {
                        zoomLevel = 14.5;
                    } else {
                        zoomLevel = 6;
                    }
                    if (this.ukFetch) {
                        zoomLevel = 6;
                    }

                    this.map.setZoom(zoomLevel);




                } else {
                    this.map.setZoom(9);
                }
                console.log(this.map.getZoom());
            },

            scrollToBuilding(building) {
                const domBuilding = document.getElementById(`id_${building.id}`);
                const buildingPos = domBuilding.offsetTop;
                let scrollContainer = document.querySelector('.search-results-buildings');

                TweenLite.to(scrollContainer, 0.5, {
                    scrollTo: {
                        y: buildingPos,
                        autoKill: false,
                    },
                });
            },

            mobileListSlideTo(building) {
                const slides = this.buildingsMobilerSlider.slides;
                let slideIndex = 0;
                const slidesLength = slides.length;
                for (let i = 0; i < slidesLength; i++) {
                    const elementId = slides[i].getAttribute('data-id');
                    if (+elementId === +building.id) {
                        slideIndex = i;
                        break;
                    }
                }
                this.buildingsMobilerSlider.slideTo(slideIndex);
            },

            mobileListClick(id) {
                const building = this.buildings[id];
                const marker = building.marker;
                if (building.markerIsOutFilter || building.markerIsOutArea) {
                    this.selectedHiddenMarker = building;
                } else {
                    this.selectedHiddenMarker = false;
                }
                this.hoveredBuilding = building.id;

            },
            mobileMarkerClick(data) {
                const building = this.buildings[data.id];
                const marker = building.marker;
                if (marker.infoWindow) return;
                this.activeBuilding = -1;

                const api = 'https://www.google.com/maps/dir/?api=1';
                const origin = this.searchInput;
                const destination = building.address;
                const directions = `${api}&origin=${origin}&destination=${destination}`;
                building.directions = directions;

                const infoWindowContent = infoWindowMobile(building);
                if (building.markerIsOutFilter || building.markerIsOutArea) {
                    this.selectedHiddenMarker = building;
                } else {
                    this.selectedHiddenMarker = false;
                }
                this.hoveredBuilding = building.id;

                this.mobileInfoWindowHtml = infoWindowContent;
                this.mobileInfoWindowOpened = true;

                // Attach the event listener to the close button after the DOM update
                this.$nextTick(() => {
                    const closeButton = document.querySelector('.google-info-window-mobile__close');
                    if (closeButton) {
                        closeButton.addEventListener('click', () => {
                            this.closeMobileInfoWindow();
                        });
                    }
                });
            },

            /**
             * Close info window
             * @param data
             */
            desktopMarkerClick (data) {
                if (data.infoWindow) {
                    data.infoWindow.close();
                }
            },

            initInfoWindow(building) {
                const marker = building.marker;
                if (marker.infoWindow) return;
                this.activeBuilding = -1;

                const api = 'https://www.google.com/maps/dir/?api=1';
                const origin = this.searchInput;
                const destination = building.address;
                const infoWindowData = {
                    name: building.name,
                    link: building.link,
                    directions: `${api}&origin=${origin}&destination=${destination}`,
                    address: building.address,
                    transport: building.transport,
                };
                if (window.innerWidth > 768) {
                    marker.infoWindow = new google.maps.InfoWindow({
                        content: infoWindow(infoWindowData),
                    });

                    marker.infoWindow.open(this.map, marker);
                    this.activeBuilding = building.id;

                    google.maps.event.addListener(marker.infoWindow, 'closeclick', () => {
                        this.activeBuilding = -1;
                        if (this.selectedHiddenMarker) {
                            this.selectedHiddenMarker = false;
                            this.filterList();
                            TweenLite.to(window, 0, {
                                scrollTo: 0,
                            });
                        }
                    });

                    // Once info window dom is ready, attach event listener for close button
                    google.maps.event.addListener(marker.infoWindow, 'domready', () => {
                        const closeButton = document.querySelector('.google-info-window__close');

                        if (closeButton) {
                            closeButton.addEventListener('click', () => {
                                this.desktopMarkerClick(marker);
                            });
                        }
                    });
                }
            },

            initAutocomplete() {
                const input = this.$refs.searchInput;
                const autocomplete = new google.maps.places.Autocomplete(input);
                autocomplete.setComponentRestrictions({ 'country': ['uk'] });

                autocomplete.bindTo('bounds', this.map);
                const service = new google.maps.places.AutocompleteService();

                autocomplete.addListener('place_changed', () => {
                    this.searchErrorValue = '';

                    const place = autocomplete.getPlace();
                    // Console log the search area radius
                    // Zoom in to the search area
                    this.zoomMapByGeometry(place.geometry);
                    if (!place.geometry) {

                        service.getPlacePredictions({
                            input: input.value,
                            componentRestrictions: { country: 'uk' },
                        }, (predictions, status) => {
                            if (status === this.statusOk) {
                                const placeId = predictions[0].place_id;
                                const geocoder = new google.maps.Geocoder;
                                geocoder.geocode({ placeId: placeId }, (results, status) => {
                                    if (status === this.statusOk) {
                                        const firstRes = results[0];
                                        const geometry = firstRes.geometry;
                                        this.fillInput(place.name);
                                        this.zoomMapByGeometry(geometry);
                                        this.setDataToUrl({ value: place.name });
                                    } else {
                                        this.showAllBuildings(place.name);
                                    }
                                    this.generateList();
                                });
                            } else {
                                this.showAllBuildings(place.name);
                                this.generateList();
                            }
                        });
                    } else {
                        this.zoomMapByGeometry(place.geometry);
                        // this.generateList();
                        this.setDataToUrl({ id: place.place_id });
                        this.setDataToUrl({ placeId: place.place_id });
                        // Remove value from URL
                        this.setDataToUrl({ value: '' });

                        // Get the search parameters from the URL
                        let searchParams = new URLSearchParams(window.location.search);

                        let params = {
                            value: place.name,
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng(),
                            space_type: searchParams.get('space_type'),
                            amenities: searchParams.get('amenities'),
                            capacity: searchParams.get('capacity'),
                            placeId: searchParams.get('place_id'),
                            radius: searchParams.get('radius'),
                        };

                        // Filter out empty parameters
                        params = Object.fromEntries(Object.entries(params).filter(([_, v]) => v != null && v !== ''));

                        // API endpoint
                        let apiUrl = `${window.location.origin}/wp-json/landmark/v1/locations`;
                        this.apiLoading = true;
                        axios.get(apiUrl, { params: params })
                            .then(response => {
                                // Process and update the data
                                this.allMarkers = response.data.locations;
                                this.generateResultText();
                                this.initMap(this.allMarkers);
                            }).then(() => {
                                this.apiLoading = false;
                            })

                            .then(() => {
                                if (params.space_type) {
                                    // Reset all selectedFilters first
                                    Object.keys(this.selectedFilters).forEach(key => {
                                        this.selectedFilters[key] = false;
                                    });

                                    // Split the params.space_type by comma to handle multiple filters
                                    const spaceTypes = params.space_type.split(',');
                                    spaceTypes.forEach(type => {
                                        // The URL might encode spaces as plus signs (+), so replace them with spaces
                                        const decodedType = decodeURIComponent(type).replace(/\+/g, ' ');
                                        // Now update the selectedFilters, ensuring keys match the text exactly
                                        if (this.selectedFilters.hasOwnProperty(decodedType)) {
                                            this.selectedFilters[decodedType] = true;
                                        }
                                    });
                                } else {
                                    // If no space_type parameter, reset all selectedFilters
                                    Object.keys(this.selectedFilters).forEach(key => {
                                        this.selectedFilters[key] = false;
                                    });
                                }

                                if (params.amenities) {
                                    Object.keys(this.selectedAmenitiesFilters).forEach(key => {
                                        this.selectedAmenitiesFilters[key] = false;
                                    });
                                    let amenities = params.amenities.split(',');
                                    amenities.forEach(amenity => {
                                        this.selectedAmenitiesFilters[amenity] = true;
                                    });
                                } else {
                                    Object.keys(this.selectedAmenitiesFilters).forEach(key => {
                                        this.selectedAmenitiesFilters[key] = false;
                                    });
                                }

                            }).then(() => {
                                this.filtersNum = 0;
                                if (params.space_type) {
                                    this.filtersNum += 1;
                                }

                                if (params.amenities) {
                                    this.filtersNum += 1;
                                }

                                if (params.capacity) {
                                    this.filtersNum += 1;
                                }
                            })
                            .catch(error => {
                                // Handle errors
                                console.error("Error fetching filtered locations:", error);
                            });
                        this.generateList();
                    }
                });
            },

            closeMobileInfoWindow() {
                this.mobileInfoWindowOpened = false;
            },

            /**
             * Initialise Map
             * @param buildings
             */
            initMap(buildings) {
                // console.log("Invoked the initMap method")
                //reset buildings everytime map is initialised
                this.buildings = {};

                const dataUrl = this.getDataFromUrl();
                const placeId = dataUrl.placeId;
                const lat = dataUrl.lat;
                const lng = dataUrl.lng;
                const value = dataUrl.value;
                const filter = dataUrl.filter;
                //this.filterPeople = dataUrl.people;

                if (value) {
                    this.selectedCity = value.toLowerCase() || '';
                }

                // Grab product type in URL and convert to lowercase and replace - with space.
                if (dataUrl.product_type) {
                    let productType = dataUrl.product_type;
                    productType = productType.toLowerCase() || '';
                    productType = productType.replace(/-/g, ' ');
                    this.productType = productType;
                }

                // Get the tier from the URL and assign to data.
                if (dataUrl.tier) {
                    this.tier = dataUrl.tier;
                }

                const generateList = () => { // generate list after map init
                    const loadListener = this.map.addListener('tilesloaded', () => {
                        google.maps.event.removeListener(loadListener);
                        this.generateList();
                        this.appIsReady = true;
                        this.toggleFilterOption(filter);
                        this.toggleFilterAmenitiesOption(filter);
                        this.applyFilter();
                    });
                };

                // create map
                const styledMapType = new google.maps.StyledMapType(mapStyles, { name: 'Styled Map' });
                // Define the bounds for the UK
                var UKBounds = new google.maps.LatLngBounds(
                    new google.maps.LatLng(49.9, -7.5), // Southwest corner
                    new google.maps.LatLng(58.7, 1.8) // Northeast corner
                );

                // Initialize the map
                this.map = new google.maps.Map(this.$refs.map, {
                    disableDefaultUI: true,
                    clickableIcons: false,
                    // restriction: {
                    //     latLngBounds: UKBounds,
                    //     strictBounds: false,
                    // }
                });
                this.map.mapTypes.set('styled_map', styledMapType);
                this.map.setMapTypeId('styled_map');

                //Add event listener to google map to find centre after user has stopped dragging
                // google.maps.event.addListener(this.map, 'zoom_changed', () => {
                //     this.removeLocationsOutsideBounds();
                // });

                // Added event for initial zoom change to resize zoom
                // google.maps.event.addListenerOnce(this.map, 'zoom_changed', () => {
                //     this.removeLocationsOutsideBounds();

                //     if (this.markersResultList && (this.tier || this.productType)) {
                //         this.fitMarkersWithinBounds(this.markersResultList)
                //     }
                // });

                //Add event listener to google map to find centre after user has stopped dragging
                // google.maps.event.addListener(this.map, 'bounds_changed', () => {
                //     if (this.activeBuilding === -1) {
                //         this.removeLocationsOutsideBounds();
                //     }
                // });

                //Add event listener to google map to find centre after user has stopped dragging
                // google.maps.event.addListener(this.map, 'dragend', () => {
                //     this.removeLocationsOutsideBounds();
                // });

                buildings.forEach(building => {
                    // collect filters
                    if (!building.products) return;
                    const filters = building.products;
                    const amenities = building.amenities;
                    Object.keys(filters).forEach(key => {
                        if (key === '') {
                            return;
                        }
                        this.$set(this.selectedFilters, key, false);
                        this.$set(this.availableFilters, key, true);

                    });

                    Object.keys(amenities).forEach(key => {
                        this.$set(this.selectedAmenitiesFilters, key, false);
                        // this.$set(this.availableAmenitiesFilters, key, true);
                    });

                    // create marker
                    const pos = { lat: +building.lat, lng: +building.lng };

                    const marker = new google.maps.Marker({
                        position: pos,
                        map: this.map,
                        icon: this.markerIcons(building.location_source).default,
                        zIndex: 2,
                        title: building.name,
                    });

                    // add actions for marker
                    marker.addListener('click', () => {
                        this.hoveredBuilding = building.id;
                        if (window.innerWidth < 1024) {
                            this.mobileMarkerClick(building);
                        }
                        if (building.markerIsOutFilter) {
                            this.selectedHiddenMarker = building;
                        } else {
                            if (window.innerWidth < 1024) {
                                this.mobileListSlideTo(building);
                                this.mobileInfoWindowOpened = true;
                                // Pass the building to the mobile info window
                            } else {
                                this.scrollToBuilding(building);
                            }
                            this.selectedHiddenMarker = false;
                        }
                        if (window.innerWidth < 1024) {
                            this.mobileInfoWindowBuilding = building;
                        } else {
                            this.initInfoWindow(building);
                        }
                    });
                    marker.addListener('mouseover', () => {
                        this.hoveredBuilding = building.id;
                    });
                    marker.addListener('mouseout', () => {
                        this.hoveredBuilding = -1;
                    });

                    // add marker to building
                    building.marker = marker;
                    building.markerIsOutArea = false; // marker status
                    building.markerIsOutFilter = false; // marker status

                    // generate main buildings object
                    this.buildings[building.id] = building;
                    this.allMarkers[building.id] = building;

                });

                // center map by data we have
                if (placeId || lat && lng || value) {
                    const geocoder = new google.maps.Geocoder;
                    if (placeId) {
                        geocoder.geocode({ placeId: placeId }, (results, status) => {
                            if (status === this.statusOk) {
                                const firstRes = results[0];
                                this.fillInput(firstRes.formatted_address);
                                this.zoomMapByGeometry(firstRes.geometry);

                                //TODO : uncomment to apply map zoom and reorder results
                                // // Pass second parameter to default zoom
                                // this.zoomMapByGeometry(firstRes.geometry, true);

                                //calculate distance between search point and locations
                                buildings.map((building) => {
                                    const destination = new google.maps.LatLng(building.lat, building.lng);

                                    building.distance = google.maps
                                        .geometry
                                        .spherical
                                        .computeDistanceBetween(results[0].geometry.location, destination) / 1609.34;
                                })
                            } else {
                                this.showAllBuildings();
                            }
                            generateList();
                        });
                    } else if (lat && lng) {
                        geocoder.geocode({ 'location': { lat: lat, lng: lng } },
                            (results, status) => {
                                if (status === 'OK') {
                                    const firstRes = results[0];
                                    this.fillInput(firstRes.formatted_address);
                                    this.zoomMapByGeometry(firstRes.geometry);
                                } else {
                                    this.showAllBuildings();
                                }
                                generateList();
                            });
                    } else {
                        const service = new google.maps.places.AutocompleteService();
                        service.getPlacePredictions({
                            input: value,
                            componentRestrictions: { country: 'uk' },
                        }, (predictions, status) => {
                            if (status === this.statusOk) {
                                const placeId = predictions[0].place_id;
                                geocoder.geocode({ placeId: placeId }, (results, status) => {
                                    if (status === this.statusOk) {
                                        const firstRes = results[0];
                                        this.fillInput(value);

                                        // TODO : remove
                                        this.zoomMapByGeometry(firstRes.geometry);

                                        //TODO : uncomment to apply map zoom and reorder results
                                        // Pass second parameter to default zoom
                                        // this.zoomMapByGeometry(firstRes.geometry, true);
                                        //
                                        //calculate distance between search point and locations
                                        buildings.map((building) => {
                                            const destination = new google.maps.LatLng(building.lat, building.lng);

                                            building.distance = google.maps
                                                .geometry
                                                .spherical
                                                .computeDistanceBetween(results[0].geometry.location, destination) / 1609.34;
                                        })
                                    } else {
                                        this.showAllBuildings(value);
                                    }
                                });
                            } else {
                                this.showAllBuildings(value);
                            }
                            generateList();
                        });
                    }
                } else {
                    this.showAllBuildings();
                    generateList();
                }



                // Filter location autocomplete in search
                // this.initAutocomplete();
            },

            /**
             * Set marker Icon to Landmark or thespace
             * @param locationSource
             * @returns {*|{}}
             */
            markerIcons(locationSource) {
                const source = locationSource || "Landmark";

                return markerIcons(source);
            },

            /**
             * Select city and add parameters to URL
             * @param city
             */
            selectCity(city) {
                const urlParams = new URLSearchParams(window.location.search);

                urlParams.set('value', city);

                window.location.search = urlParams;
            },

            /**
             * Apply the zoom level to the URL
             * @param zoom
             * @param zoomInteger
             */
            applyZoom(zoom, zoomInteger) {
                if (zoom === 'add') {
                    this.map.setZoom(this.map.getZoom() + parseInt(zoomInteger));
                } else {
                    this.map.setZoom(this.map.getZoom() - parseInt(zoomInteger));
                }
            },

            /**
             * Remove locations from map if they are not within bounds
             */
            removeLocationsOutsideBounds() {
                let allLocations = [];
                let filteredLocations = this.allMarkers;

                Object.keys(filteredLocations).forEach(key => {
                    const building = filteredLocations[key];

                    if (filteredLocations[key] &&
                        filteredLocations[key].marker &&
                        this.map &&
                        this.map.getBounds() &&
                        !this.map.getBounds().contains(filteredLocations[key].marker.getPosition())
                    ) {
                        filteredLocations[key].marker.setMap(null);
                    } else {
                        // Check if product type or tier is set and filter and remove markers.
                        if (
                            (
                                this.productType &&
                                filteredLocations[key] &&
                                !this.filterByProductType(filteredLocations[key])
                            ) ||
                            (
                                this.tier &&
                                filteredLocations[key] &&
                                !this.filterByTier(filteredLocations[key])
                            )
                        ) {
                            filteredLocations[key].marker.setMap(null);
                        } else {
                            allLocations.push(building);
                            filteredLocations[key].marker.setMap(this.map);
                        }
                    }
                });

                //TODO : add in to reorder
                // Reorder locations based on distance
                allLocations.sort((a, b) => a.distance - b.distance);

                this.markersResultList = this.orderHighlightedUnits(allLocations);
                this.generateResultText();
            },

            /**
             * Remove commas and replace with line breaks in address
             * @param address
             * @returns {*}
             */
            addressFormat(address) {
                return address.split(",").join("<br />")
            },

            /**
             * Set target for href
             * @param data
             * @returns {*|string}
             */
            setTarget(data) {
                return data.book_a_meeting_room_button_details ?
                    data.book_a_meeting_room_button_details.target :
                    '_self';
            },

            /**
             * Place highlighted units at the beginning of the search results buildings
             * @param locations
             * @returns {*[]}
             */
            orderHighlightedUnits(locations) {
                let highlightedLocations = [];
                let normalLocations = [];

                Object.keys(locations).forEach(key => {
                    const building = locations[key];

                    if (building.highlight) {
                        highlightedLocations.push(building);
                    } else {
                        normalLocations.push(building);
                    }
                });

                return highlightedLocations.concat(normalLocations);
            },

            /**
             * Filter location and check if product type exists within product.
             * @param location
             * @returns {boolean}
             */
            filterByProductType(location) {
                const products = location.products;

                if (products) {
                    // Check if product type exists within product.
                    if (products && products[this.productType]) {
                        return true;
                    }
                }

                return false;
            },

            /**
             * Check if location has tier equal to param
             * @param location
             * @returns {boolean}
             */
            filterByTier(location) {
                return location.tier === this.tier;
            },

            /**
             * Move map to focus on markers on map.
             * @param markers
             */
            fitMarkersWithinBounds(markers) {
                const markerBounds = new google.maps.LatLngBounds();

                Object.keys(markers).forEach(key => {
                    const marker = markers[key].marker;
                    const position = marker.getPosition();
                    const point = new google.maps.LatLng(position.lat(), position.lng());
                    markerBounds.extend(point);
                });

                if (this.map) {
                    this.map.fitBounds(markerBounds);
                }
            },

            searchSubmit() {
                // console.log("Invoked the searchSubmit method");

                this.searchInput = this.$refs.searchInput.value;

                // Update the URL with the search input
                this.setDataToUrl({ value: this.searchInput });

                // Search the location and update the map
                this.searchLocation();

            },

            searchLocation() {
                // console.log("Invoked the searchLocation method");

                const geocoder = new google.maps.Geocoder;
                const address = this.searchInput;

                geocoder.geocode({ address: address }, (results, status) => {
                    if (status === this.statusOk) {
                        const firstRes = results[0];
                        this.fillInput(firstRes.formatted_address);
                        this.zoomMapByGeometry(firstRes.geometry);
                        this.generateList();
                    } else {
                        this.showAllBuildings(address);
                        this.generateList();
                    }
                });
            },

            searchInputHandler() {
                // console.log("Invoked the searchInputHandler method");
                // Google geo autocomplete
                const input = this.$refs.searchInput;
                const autocomplete = new google.maps.places.Autocomplete(input);
                autocomplete.setComponentRestrictions({ 'country': ['uk'] });

                autocomplete.bindTo('bounds', this.map);
                const service = new google.maps.places.AutocompleteService();

                autocomplete.addListener('place_changed', () => {
                    this.searchErrorValue = '';

                    const place = autocomplete.getPlace();

                    if (!place.geometry) {
                        this.isValidSuggestion = false;
                        service.getPlacePredictions({
                            input: input.value,
                            componentRestrictions: { country: 'uk' },
                        }, (predictions, status) => {
                            if (status === this.statusOk) {
                                const placeId = predictions[0].place_id;
                                const geocoder = new google.maps.Geocoder;

                                geocoder.geocode({ placeId: placeId }, (results, status) => {
                                    if (status === this.statusOk) {
                                        const firstRes = results[0];
                                        const geometry = firstRes.geometry;
                                        this.fillInput(place.name);
                                        this.zoomMapByGeometry(geometry);
                                        this.setDataToUrl({ value: place.name });
                                    } else {
                                        this.showAllBuildings(place.name);
                                    }
                                    this.generateList();
                                });
                            } else {
                                this.showAllBuildings(place.name);
                                this.generateList();
                            }
                        });
                    } else {
                        this.isValidSuggestion = true;
                        this.zoomMapByGeometry(place.geometry);
                        this.generateList();
                        this.setDataToUrl({ id: place.place_id });
                    }
                });

                // Filter location autocomplete in search
                this.initAutocomplete();

            },
            handleEnterKey(event) {
                if (event.key === 'Enter' && !this.isValidSuggestion) {
                    event.preventDefault(); // Prevent the form from submitting
                    console.log('Enter key pressed and i will do some magic');
                    const service = new google.maps.places.AutocompleteService();
                    const input = this.$refs.searchInput.value; // Get the current input value

                    service.getPlacePredictions({
                        input: input,
                        componentRestrictions: { country: 'uk' },
                    }, (predictions, status) => {
                        if (status === google.maps.places.PlacesServiceStatus.OK && predictions.length > 0) {
                            const placeId = predictions[0].place_id;
                            const geocoder = new google.maps.Geocoder();

                            geocoder.geocode({ placeId: placeId }, (results, status) => {
                                if (status === google.maps.places.PlacesServiceStatus.OK) {
                                    this.isValidSuggestion = true; // Mark as valid since we're programmatically selecting
                                    const place = results[0];
                                    this.$refs.searchInput.value = place.formatted_address; // Update input with the first suggestion's address
                                    this.zoomMapByGeometry(place.geometry); // Adjust map
                                    this.generateList(); // Update list
                                    this.setDataToUrl({ id: place.place_id }); // Update URL
                                    this.fillInput(place.formatted_address); // Update the input field

                                    let apiUrl = `${window.location.origin}/wp-json/landmark/v1/locations`;
                                    let params = {
                                        value: place.formatted_address,
                                        lat: place.geometry.location.lat(),
                                        lng: place.geometry.location.lng(),
                                    };
                                    // Check if we have any filters like space_type, amenities, capacity
                                    const searchParams = new URLSearchParams(window.location.search);
                                    if (searchParams.get('space_type')) {
                                        params.space_type = searchParams.get('space_type');
                                    }
                                    if (searchParams.get('amenities')) {
                                        params.amenities = searchParams.get('amenities');
                                    }
                                    if (searchParams.get('capacity')) {
                                        params.capacity = searchParams.get('capacity');
                                    }
                                    if (searchParams.get('radius')) {
                                        params.radius = searchParams.get('radius');
                                    }

                                    this.apiLoading = true;
                                    this.fetchLocations(apiUrl, params);
                                }
                            });

                        } else {
                            alert(`No valid locations found for "${input}". Please try again.`);
                        }
                    });

                }
            },

            filterLocations() {
                // Get the current URL parameters
                const searchParams = new URLSearchParams(window.location.search);
                const filterButton = document.querySelector('.search-results-filter__footer .search-results-filter__apply button');

                // If button is loading or disabled, do nothing
                if (filterButton.classList.contains('loading') || filterButton.disabled) {
                    return;
                }

                // Remove the following if block if you want to keep the tier in the URL
                if (searchParams.get('tier')) {
                    // Remove tier from the URL
                    searchParams.delete('tier');
                    window.history.replaceState({}, '', `${window.location.pathname}?${searchParams.toString()}`);
                }
                // Add Loading class to button
                filterButton.classList.add('loading');
                filterButton.disabled = true;

                let params = {
                    space_type: searchParams.get('space_type'),
                    amenities: searchParams.get('amenities'),
                    capacity: searchParams.get('capacity'),
                    value: searchParams.get('value'),
                    lat: searchParams.get('lat'),
                    lng: searchParams.get('lng'),
                    placeId: searchParams.get('place_id'),
                };


                // Filter out empty parameters
                params = Object.fromEntries(Object.entries(params).filter(([_, v]) => v != null && v !== ''));
                // Check if there is radius in the URL
                if (searchParams.get('radius')) {
                    params.radius = searchParams.get('radius');
                }

                let apiUrl = `${window.location.origin}/wp-json/landmark/v1/locations`;
                this.apiLoading = true;
                axios.get(apiUrl, { params: params })
                    .then(response => {
                        this.allMarkers = response.data.locations;
                        // filteredLocations
                        this.generateResultText();
                        this.initMap(this.allMarkers);
                    })
                    .then(() => {
                        // Toggle the filter
                        // this.toggleFilter();
                        // Remove loading class from button
                        filterButton.classList.remove('loading');
                        filterButton.disabled = false;
                        this.setFiltersFromUrlParams();



                    }).then(() => {
                        this.apiLoading = false;
                    }).then(() => {
                        // Update the selectedFilters object from the URL
                        if (params.space_type) {
                            // Reset all selectedFilters first
                            Object.keys(this.selectedFilters).forEach(key => {
                                this.selectedFilters[key] = false;
                            });

                            // Split the params.space_type by comma to handle multiple filters
                            const spaceTypes = params.space_type.split(',');
                            spaceTypes.forEach(type => {
                                // The URL might encode spaces as plus signs (+), so replace them with spaces
                                const decodedType = decodeURIComponent(type).replace(/\+/g, ' ');
                                // Now update the selectedFilters, ensuring keys match the text exactly
                                if (this.selectedFilters.hasOwnProperty(decodedType)) {
                                    this.selectedFilters[decodedType] = true;
                                }
                            });
                        } else {
                            // If no space_type parameter, reset all selectedFilters
                            Object.keys(this.selectedFilters).forEach(key => {
                                this.selectedFilters[key] = false;
                            });
                        }

                        if (params.amenities) {
                            Object.keys(this.selectedAmenitiesFilters).forEach(key => {
                                this.selectedAmenitiesFilters[key] = false;
                            });
                            let amenities = params.amenities.split(',');
                            amenities.forEach(amenity => {
                                this.selectedAmenitiesFilters[amenity] = true;
                            });
                        } else {
                            Object.keys(this.selectedAmenitiesFilters).forEach(key => {
                                this.selectedAmenitiesFilters[key] = false;
                            });
                        }

                        if (params.capacity) {
                            Object.keys(this.selectedCapacityFilters).forEach(key => {
                                this.selectedCapacityFilters[key] = false;
                            });

                            this.selectedCapacityFilters[params.capacity] = true;
                        } else {
                            Object.keys(this.selectedCapacityFilters).forEach(key => {
                                this.selectedCapacityFilters[key] = false;
                            });
                        }

                    }).then(() => {
                        this.filtersNum = 0;
                        if (params.space_type) {
                            this.filtersNum += 1;
                        }

                        if (params.amenities) {
                            this.filtersNum += 1;
                        }

                        if (params.capacity) {
                            this.filtersNum += 1;
                        }
                    })
                    .catch(error => {
                        console.error("Error fetching filtered locations:", error);
                    });


            },

            calculateHeaderHeight() {
                const header = document.querySelector('header.header');
                this.headerHeight = header ? header.offsetHeight : 0;
            },
            calcElsHeights() {
                const elements = {
                    header: document.querySelector('header.header'),
                    map: document.querySelector('.search-results-map'),
                    searchResultsHeader: document.querySelector('.search-results-header'),
                };
                const heights = {};
                Object.keys(elements).forEach(key => {
                    if (elements[key]) {
                        heights[key] = elements[key].offsetHeight;
                    }
                });

                this.headerElHeight = heights.header;
                this.mapElHeight = heights.map;
                this.searchResultsHeaderElHeight = heights.searchResultsHeader;
            },

            findMe() {
                // console.log("Invoked the findMe method");
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((position) => {
                        const pos = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };

                        this.map.setCenter(pos);
                        this.map.setZoom(15);

                        // Set Marker for current location
                        const marker = new google.maps.Marker({
                            position: pos,
                            map: this.map,
                            zIndex: 2,
                            title: 'Your Location',
                        });

                    }, () => {
                        console.log("Error: The Geolocation service failed.");
                    });
                } else {
                    console.log("Error: Your browser doesn\'t support geolocation.");
                }
            }
        },
    });
}


